module.exports = __webpack_public_path__ + "static/media/company_blockchain_bagels.d1a15d04.svg";